"use strict";

import angular from "angular";

import { Scenario } from "../../../gateway/Scenario/Scenario";

class EditScenarioFormDialog {
    loading = false;
    form = {};
    formModel = { scenarioName: "" };
    Scenario = new Scenario();

    constructor(locals, DSNDialogService, $mdDialog, $scope) {
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.$scope = $scope;

        this.formModel.scenarioName = this.locals.scenario.name;
    }

    $onInit() {}

    async onSubmit() {
        this.loading = true;
        const scenarioExists = this.locals.scenarios.find(
            (scenario) =>
                scenario.name.toUpperCase() ===
                    this.formModel.scenarioName.toUpperCase() &&
                scenario._id != this.locals.scenario._id
        );
        if (scenarioExists) {
            this.loading = false;
            this.form.scenarioName.$setValidity("duplicate", false);
            this.$scope.$applyAsync();
            return false;
        } else this.form.scenarioName.$setValidity("duplicate", true);
        await this.Scenario.updateNameById({
            _id: this.locals.scenario._id,
            name: this.formModel.scenarioName
        });
        this.loading = false;
        this.$mdDialog.hide(this.formModel.scenarioName);
    }

    onChangeScenario() {
        this.form.scenarioName.$setValidity("duplicate", true);
    }
}
angular.module("nucont.shared").controller("EditScenarioFormDialog", [
        "locals",
        "DSNDialogService",
        "$mdDialog",
        "$scope",
        EditScenarioFormDialog
    ]);
